import { Component, computed, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomisedSingleSelectComponent, ISingleSelectOption } from '@components/customised-single-select/customised-single-select.component';
import { orderBy } from 'lodash';
import { UserService } from 'src/app/services/user.service';
import { values } from 'underscore';

@Component({
    selector: 'app-selector-single-user',
    imports: [CustomisedSingleSelectComponent],
    templateUrl: './selector-single-user.component.html',
    styleUrl: './selector-single-user.component.scss'
})
export class SelectorSingleUserComponent {
  label = input.required();
  control = input.required<FormControl<string>>();
  activeUserOnly = input();
  submitted = input(false);
  userService = inject(UserService);

  options = computed(() => orderBy(values(this.userService.managedOrgUserDictionaryByOrgUserID)
  .filter( u => (this.activeUserOnly() ? (u.status === 'Active') : true))
  .map(u => ({value: u.orgUserID, label: u.fullName, imgUrl: u.userDetail?.profilePicURL}))
  ));
}
